import SubpageLayout from "@/components/SubpageLayout";
import { P, Section } from "@/components/Prose";
import { openCookieSettings } from "@/components/CookieConsent";

const Privatlivspolitik = () => (
  <SubpageLayout
    overline="TRAUMEBEVIDST UDVIKLING"
    title="Privatlivs- og cookiepolitik"
    testId="page-privatlivspolitik"
  >
    <Section title="Dataansvarlig">
      <P>
        Traumebevidst Udvikling, CVR 42608769, er dataansvarlig for behandlingen af
        personoplysninger på denne hjemmeside. Har du spørgsmål, kan du skrive til
        kontakt@traumebevidstudvikling.dk.
      </P>
    </Section>

    <Section title="Cookies og sporingsteknologier">
      <P>
        Hjemmesiden bruger ingen cookies til markedsføring, og der er ikke indlejret indhold fra
        tredjepart (f.eks. videoer eller sociale medier), som sætter cookies. Skrifttyperne hostes
        lokalt på vores egen server, så der deles ingen oplysninger med eksterne fonttjenester.
      </P>
      <P>Vi anvender følgende teknologier:</P>
      <P>
        <strong className="font-medium">Nødvendige (kræver ikke samtykke):</strong> Dit valg om
        cookies gemmes i din browsers lokale lagring (nøglen ”tb-cookie-consent”), så vi kan huske
        dit samtykke. Denne lagring indeholder ingen personoplysninger og er teknisk nødvendig for,
        at hjemmesiden kan respektere dit valg.
      </P>
      <P>
        <strong className="font-medium">Statistik (kræver samtykke):</strong> Hvis du accepterer,
        bruger vi statistikværktøjet PostHog via vores hostingplatform Emergent til anonyme
        besøgsstatistikker og sessionsoptagelse. Formålet er udelukkende at forstå, hvordan
        hjemmesiden bruges, så vi kan forbedre indhold og brugeroplevelse. Værktøjet sætter
        førsteparts-cookies og lokal lagring (nøgler, der begynder med ”ph_”) og aktiveres først,
        når du har givet samtykke.
      </P>
    </Section>

    <Section title="Kontaktformularen">
      <P>
        Når du skriver til os via kontaktformularen, sendes dine oplysninger (navn, e-mail og
        besked) som en e-mail til os. Oplysningerne gemmes ikke i en database på hjemmesiden. Vi
        bruger dem alene til at svare på din henvendelse og sletter korrespondancen, når
        henvendelsen er afsluttet.
      </P>
    </Section>

    <Section title="Sådan ændrer eller trækker du dit samtykke tilbage">
      <P>
        Du kan til enhver tid ændre eller trække dit samtykke tilbage. Klik på knappen herunder,
        eller på ”Cookieindstillinger” nederst på alle sider. Hvis du trækker samtykket tilbage,
        stoppes statistikmålingen, og de tilhørende data i din browser slettes.
      </P>
      <p className="pt-2">
        <button
          type="button"
          data-testid="open-cookie-settings"
          onClick={openCookieSettings}
          className="rounded-full border border-[#3F5A47]/40 px-6 py-2.5 text-sm font-medium text-[#3F5A47] transition-colors duration-300 hover:border-[#B46A45] hover:text-[#B46A45]"
        >
          Ændr cookieindstillinger
        </button>
      </p>
    </Section>

    <Section title="Dine rettigheder">
      <P>
        Efter databeskyttelsesforordningen (GDPR) har du ret til indsigt i de oplysninger, vi
        behandler om dig, ret til berigtigelse, sletning og indsigelse samt ret til at klage til
        Datatilsynet (www.datatilsynet.dk). Kontakt os på kontakt@traumebevidstudvikling.dk, hvis
        du vil gøre brug af dine rettigheder.
      </P>
    </Section>
  </SubpageLayout>
);

export default Privatlivspolitik;
